<template>
  <div class="page-container">
    <div id="searchArea">
      <div class="clearfix">
        <div class="fl pb10">
          <el-button type="primary" @click="addOrUpdateHandle()">Add Billing Exchange Rate</el-button>
        </div>
        <div class="fr">
          <el-form class="el-form-filter" :inline="true" :model="dataForm" @keyup.enter.native="getDataList(1)">
            <el-form-item>
              <el-select v-model="dataForm.fromCurrency" filterable clearable placeholder="From Currency" class="wdb100">
                <el-option v-for="item in currencyList" :key="`from-${item.currency}`" :label="item.currency" :value="item.currency"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select v-model="dataForm.toCurrency" filterable clearable placeholder="To Currency" class="wdb100">
                <el-option v-for="item in currencyList" :key="`modal-to-${item.currency}`" :label="item.currency" :value="item.currency"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" type="primary" plain v-debounce @click="getDataList(1)">Search</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <div>
      <el-table
        max-height="680"
        v-loading="dataListLoading"
        :data="dataList"
        @sort-change="tableSortChange"
        :default-sort="{ prop: 'createTime', order: 'descending' }"
        style="width: 100%"
      >
        <el-table-column label="From Currency" prop="fromCurrency" align="center" />
        <el-table-column label="To Currency" prop="toCurrency" align="center" />
        <el-table-column label="Exchange Rate" prop="exchangeRate" align="center" />
        <el-table-column label="Create Time" prop="createTime" align="center" width="180" sortable="custom" />
        <el-table-column label="Update Time" prop="updateTime" align="center" width="180" />
        <el-table-column label="Action" width="120" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" class="fwb" @click="addOrUpdateHandle(scope.row)">Edit</el-button>
            <el-button type="text" class="fwb" @click="deleteHandle(scope.row)">Delete</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <pagination
      :current="current"
      :pageSize="pageSize"
      :totalCount="totalCount"
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
    ></pagination>

    <!-- 新建或修改 = 弹窗 -->
    <add-or-update-dialog ref="addOrUpdateDialog" @update="getDataList" />
  </div>
</template>

<script>
import AddOrUpdateDialog from "./modal/AddOrUpdate";
import Pagination from "@/components/Pagination";
import paginationMixin from "@/mixins/paginationMixin";
import tableMixin from "@/mixins/tableMixin";
import { mapState } from "vuex";
export default {
  mixins: [paginationMixin, tableMixin],
  components: {
    AddOrUpdateDialog,
    Pagination,
  },
  data() {
    return {
      dataForm: {
        fromCurrency: "",
        toCurrency: "",
        "orders[0].asc": false,
        "orders[0].column": "id",
      },
      dataList: [],
      dataListLoading: false,
    };
  },
  computed: {
    ...mapState("currency", ["currencyList"]),
  },
  methods: {
    // 获取数据分页
    async getDataList(current) {
      this.dataListLoading = true;
      if (current) {
        this.current = current;
      }
      const params = {
        current: this.current,
        size: this.pageSize,
        ...this.dataForm,
      };
      const { code, data } = await this.$http.get("/admin/billingExchangeRate/paging", {
        params,
      });
      if (code === 200) {
        this.dataList = data.records;
        this.totalCount = data.total;
      } else {
        this.dataList = [];
        this.totalCount = 0;
      }
      this.dataListLoading = false;
    },
    // 删除
    async deleteHandle(row) {
      await this.$confirm(`Delete this Billing Exchange Rate. Continue?`, "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      });
      const { code, msg } = await this.$http.post(`/admin/billingExchangeRate/delete/${row.id}`);
      if (code === 200) {
        this.$message({
          message: "success",
          type: "success",
          duration: 1500,
          onClose: () => {
            // mixins
            this.singleDataDelete();
            this.getDataList();
          },
        });
      } else {
        this.$message.error(msg);
      }
    },
    // 新增 / 修改
    addOrUpdateHandle(row) {
      this.$refs.addOrUpdateDialog.init(row);
    },
  },
  activated() {
    this.getDataList();
  },
};
</script>

<style lang="scss" scoped></style>
